module.exports = __webpack_public_path__ + "img/badge-arts-and-entertainment.29ad4ce8.svg";